<template>
  <v-form v-model="isBatchInfoValid" onSubmit="return false;">
    <v-card>
      <v-card-title primary-title>
        <h1>Actualizar Datos del Lote</h1>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              name="label"
              label="Etiqueta"
              id="id"
              v-model="newData.label"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-menu
              ref="menuDate"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              >
              <template slot="activator">
                <v-text-field
                  v-model="selectedDate"
                  label="Fecha de envio"
                  prepend-icon="event"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="selectedDate"
                no-title
                scrollable
                locale="es-MX"
                >
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="menuDate = false">Cancelar</v-btn>
                <v-btn flat color="primary" @click="$refs.menuDate.save(selectedDate)">Seleccionar</v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex>
        </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click="$emit('close-batch-data')">Cancelar</v-btn>
        <v-btn color="success" @click="updateBatch" :disabled="!isBatchInfoValid">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>

import moment from 'moment';

import { updateBatch } from '../../services/batch';

export default {
  props: ['batch'],
  data() {
    return {
      isBatchInfoValid: true,
      defaultNewData: {
        send_date: '',
        label: '',
      },
      newData: {},
      menu2: true,
      selectedDate: '',
    };
  },
  watch: {
    batch() {
      let tempDate = '';
      if (this.batch.send_date) {
        tempDate = moment(String(this.batch.send_date)).format('DD/MM/YYYY');
      }
      this.selectedDate = this.parseDate(tempDate);
      const retrievedData = {
        label: this.batch.label,
        send_date: this.selectedDate,
      };
      this.newData = Object.assign({}, retrievedData);
    },
    selectedDate() {
      this.newData = Object.assign(this.newData, {send_date: this.selectedDate});
    },
  },
  methods: {
    async updateBatch() {
      try {
        const result = await updateBatch(this.batch.id, this.newData);
        this.$emit('success', result.data);
      } catch (error) {
        this.$emit('error', error.message);
      }
    },
    parseDate(date) {
      if (!date) {
        return null;
      }

      const [day, month, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
  },
};
</script>
